import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { AuthProvider } from './contexts/AuthContext.jsx';
import { routeTree } from './routeTree.gen';

import './styles/app.css';
import './styles/search.css';
import './styles/extras.css';
import './styles/profile-view.css';
import './styles/research-dossier.css';
import './styles/login.css';
import './styles/build-report.css';
import './styles/signals.css';

// Route components read auth via useAuth() (AuthProvider wraps
// RouterProvider below), so there's no need to thread it through router
// context as well — see src/routes/__root.jsx for the auth gate.
const router = createRouter({ routeTree });

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </React.StrictMode>,
);
